/* Shop All (sections/bb-shop-all-grid.liquid).
   facets.js re-renders the grid, filters and counts; this keeps the pieces it doesn't own in step with the URL:
   - category shortcut links (keep current filters + sort) and their active state
   - the mobile Sort select, which sits outside the filter drawer but belongs to its form */
(() => {
  const TYPE = 'filter.p.product_type';
  const trim = (p) => p.replace(/\/+$/, '') || '/';

  function syncShortcuts() {
    const nav = document.querySelector('[data-bb-shortcuts]');
    if (!nav) return;
    const params = new URLSearchParams(window.location.search);
    const types = params.getAll(TYPE);
    const keep = new URLSearchParams();
    params.forEach((value, key) => {
      if (key !== TYPE && key !== 'page' && key !== 'section_id' && value !== '') keep.append(key, value);
    });
    if (!keep.has('view')) keep.set('view', nav.dataset.view);
    const path = trim(window.location.pathname);

    nav.querySelectorAll('a[data-base]').forEach((link) => {
      const query = new URLSearchParams(keep);
      // Categories without books drop filters that can't apply to them (Condition, Browse by Interest for Pantry).
      if (link.dataset.drop) link.dataset.drop.split(',').forEach((param) => query.delete(param));
      const type = link.dataset.type;
      if (link.dataset.kind === 'all' && type) query.append(TYPE, type);
      link.href = `${link.dataset.base}?${query.toString()}`;

      const active =
        link.dataset.kind === 'collection'
          ? path === trim(link.dataset.base)
          : path === trim(nav.dataset.allUrl) && (type ? types.length === 1 && types[0] === type : types.length === 0);
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function syncMobileSort() {
    const select = document.getElementById('SortBy-mobile');
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    if (select && sort && select.value !== sort && select.querySelector(`option[value="${CSS.escape(sort)}"]`)) {
      select.value = sort;
    }
  }

  function sync() {
    syncShortcuts();
    syncMobileSort();
  }

  document.addEventListener('change', (event) => {
    if (event.target.id !== 'SortBy-mobile' || typeof FacetFiltersForm === 'undefined') return;
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    const desktop = document.getElementById('SortBy');
    if (desktop) desktop.value = event.target.value;
    FacetFiltersForm.renderPage(new URLSearchParams(new FormData(form)).toString(), null);
  });

  function init() {
    sync();
    const grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(sync).observe(grid, { childList: true });
    window.addEventListener('popstate', () => setTimeout(sync, 0));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
